import { getItemValue } from '../../helpers/itemHelper'
import { CurrencyCode } from '../../types/API'
import { ITicketPrice } from '../../types/itemTypes'

export const getTicketPrice = (
  activePrices: ITicketPrice[],
  currencyCode: CurrencyCode,
): string => {
  if (!activePrices || activePrices.length === 0) return 'No prices'

  const moreThanOne = activePrices.length > 1
  const singleValue = getItemValue(activePrices[0].value, currencyCode)

  if (moreThanOne) {
    const lowestPrice = activePrices.reduce((prev, current) => {
      const isLower = Number(current.value) < Number(prev.value)
      return isLower ? current : prev
    })
    const highestPrice = activePrices.reduce((prev, current) => {
      const isHigher = Number(current.value) > Number(prev.value)
      return isHigher ? current : prev
    })

    const multiValue = `${getItemValue(
      lowestPrice.value,
      currencyCode,
    )} - ${getItemValue(highestPrice.value, currencyCode)}`

    return moreThanOne ? multiValue : singleValue
  }

  return singleValue
}
